import React from 'react'
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export default function MonModal(props) {
  //pour le modal
  const [show, setShow] = useState(props.montrer);
  const [msgModal, setMsgModal] = useState("");
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);}

  return (
    <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{props.titre}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{props.message}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        OK
      </Button>
    </Modal.Footer>
  </Modal> 

  )
}
